import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { faAngleDoubleLeft } from "@fortawesome/free-solid-svg-icons";

import "../private-app/dashboard/dashboard.scss";

// import BuyerService from "../../../services/BuyerService";

interface userConfigInterface {
  loading?: boolean,
  error?: boolean,
  success?: boolean,
  token?: any,
  initicialUser?: any,
  send: any,
};

const UserConfig: React.FC<userConfigInterface> = ({ loading, error, success, token, initicialUser, send }) => {
  //   const [isToggled, setIsToggled] = useState(false);

  const [user, setUser] = useState(initicialUser);

  // const [error, setError] = useState(false);

  const onToggle = () => {
    // setIsToggled(!isToggled)
    // event.persist();
    setUser((values: any) => ({
      ...values,
      isAuthorised: !user.isAuthorised,
    }));
  };

  const history = useHistory();

  // const handleChange = (event) => {
  //   event.persist();
  //   setUser((values) => ({
  //     ...values,
  //     [event.target.name]: event.target.value,
  //   }));
  // };

  // const handleChangeCompany = (event) => {
  //   event.persist();
  //   setUser((values) => ({
  //     ...values,
  //     company: {
  //       ...values.company,
  //       [event.target.name]: event.target.value,
  //     },
  //   }));
  // };

  // const handleChangeCompanyName = (event) => {
  //   event.persist();
  //   setUser((values) => ({
  //     ...values,
  //     company: {
  //       ...values.company,
  //       name: event.target.value,
  //     },
  //   }));
  // };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    send(user);
  };

  useEffect(() => {
    setUser(initicialUser);
    // eslint-disable-next-line
  }, [initicialUser]);

  return (
    <>
      <div className="user-config-container">
        <div className="card-container">
          <div className="card">
            <div className="card-header">
              <h1>Dados do usuário</h1>
            </div>
            <div className="card-body">
              <form className="form-container" onSubmit={handleSubmit}>
                <div className="group-input">
                  <label>Nome</label>
                  <input
                    className="global-input input-placeholder"
                    // className={`global-input ${
                    // submitted && !values.name ? "error" : ""
                    // }`}
                    id="name"
                    name="name"
                    value={user.name}
                    // onChange={handleChange}
                    disabled
                  />
                  {/* {submitted && !values.name && (
                            <span className="error-msg">Esse campo é necessario</span>
                        )} */}
                </div>
                <div className="group-input">
                  <label>Email</label>
                  <input
                    className="global-input input-placeholder"
                    // className={`global-input ${
                    // submitted && !values.email ? "error" : ""
                    // }`}
                    id="email"
                    name="email"
                    value={user.email}
                    // onChange={handleChange}
                    disabled
                  />
                  {/* {submitted && !values.email && (
                            <span className="error-msg">Esse campo é necessario</span>
                        )} */}
                </div>
                <div className="group-input">
                  <label>Empresa</label>
                  <input
                    className="global-input input-placeholder"
                    // className={`global-input ${
                    // submitted && !values.company ? "error" : ""
                    // }`}
                    id="company"
                    name="company"
                    value={user.company.name}
                    // onChange={handleChangeCompanyName}
                    disabled
                  />
                  {/* {submitted && !values.company && (
                            <span className="error-msg">Esse campo é necessario</span>
                        )} */}
                </div>
                <div className="group-input">
                  <label>CNPJ</label>
                  <input
                    className="global-input input-placeholder"
                    // className={`global-input ${
                    // submitted && !values.cnpj ? "error" : ""
                    // }`}
                    id="cnpj"
                    name="cnpj"
                    value={user.company.cnpj}
                    // onChange={handleChangeCompany}
                    disabled
                  />
                  {/* {submitted && !values.cnpj && (
                            <span className="error-msg">Esse campo é necessario</span>
                        )} */}
                </div>
                <div className="group-input switch-container">
                  <label>Status</label>
                  <label className="toggle-switch">
                    <input
                      type="checkbox"
                      checked={user.isAuthorised}
                      onChange={onToggle}
                      value={user.isAuthorised}
                    />
                    <span className="switch">
                      {user.isAuthorised ? "Ativo" : "Desativado"}
                    </span>
                  </label>
                </div>
                <button className="global-btn">
                  SALVAR{" "}
                  {loading && <FontAwesomeIcon icon={faCircleNotch} pulse />}
                </button>
              </form>
            </div>
          </div>
        </div>
        <div className="back-container">
          <button
            className="global-btn"
            onClick={() => {
              history.goBack();
            }}
          >
            <FontAwesomeIcon icon={faAngleDoubleLeft} /> VOLTAR{" "}
            {loading && <FontAwesomeIcon icon={faCircleNotch} pulse />}
          </button>
        </div>
      </div>
    </>
  );
}

export default UserConfig;